import { cn } from '@/lib/utils';

export const SadFace = () => {
  return (
    <svg
      className={cn('translate-y-[1px]')}
      xmlns="http://www.w3.org/2000/svg"
      width={12}
      height={12}
      viewBox="0 0 11 12"
      fill="none"
    >
      <path
        d="M5.5 0.304443C2.46738 0.304443 0 2.87911 0 6.04357C0 9.20804 2.46738 11.7827 5.5 11.7827C8.53262 11.7827 11 9.20804 11 6.04357C11 5.13679 10.792 4.28135 10.4315 3.51805C10.3046 3.83017 10.0967 4.09524 9.83902 4.30097C10.0396 4.84265 10.1538 5.42905 10.1538 6.04357C10.1538 8.7211 8.06596 10.8998 5.5 10.8998C2.93404 10.8998 0.846154 8.7211 0.846154 6.04357C0.846154 3.36605 2.93404 1.18739 5.5 1.18739C6.07158 1.18739 6.6173 1.30046 7.12372 1.4978C7.23372 1.23645 7.36063 0.967727 7.49474 0.701078C6.87536 0.448556 6.204 0.304443 5.5 0.304443ZM8.67308 0.304443C8.67308 0.304443 7.61538 2.19156 7.61538 2.77651C7.61538 3.36146 8.08923 3.83622 8.67308 3.83622C9.25692 3.83622 9.73077 3.36146 9.73077 2.77651C9.73077 2.19156 8.67308 0.304443 8.67308 0.304443ZM2.53846 5.16063V6.04357H4.65385V5.16063H2.53846ZM6.34615 5.16063V6.04357H8.46154V5.16063H6.34615Z"
        fill="#839AD6"
      />
    </svg>
  );
};
